/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getManagerDropdown = (params) => makeApiCall(`/manager/dropdown`, 'GET', params);
export const getRepDropdown = (params) => makeApiCall(`/medrep/dropdown`, 'GET', params);

export const getManagerByDepartment = (params) =>
  makeApiCall(`/user/managers/list`, 'POST', params);
// makeApiCall(`/user/department/manager/list`, 'POST', params);

export const getRepsByManager = (params) => makeApiCall(`/user/reps/list`, 'POST', params);
// makeApiCall(`/user/department/rep/list`, 'POST', params);

export const getRepsStratClass = (params) =>
  makeApiCall(`/user/department/rep/md-class`, 'POST', params);

export const getMdStratClass = (params) =>
  makeApiCall(`/user/department/rep/strat-class`, 'POST', params);

export const getMDDropdown = (params) => makeApiCall(`/user/doctors/list`, 'POST', params);

export const getDepartment = () => makeApiCall(`/user/departments/list`, 'GET', null);

/* Tagging v2 Filter */

export const getFilterDepartment = (params) =>
  makeApiCall(`/user/departments/list`, 'GET', params, false);

export const getFilterTeams = (params) => makeApiCall(`/user/teams`, 'POST', params, false);

export const getRepFilter = (params) => makeApiCall(`/user/reps/list`, 'POST', params);

export const getManagerFilter = (params) => makeApiCall(`/user/managers/list`, 'POST', params);
